module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "box-campaign-posts"
    }
  }, [_c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": _vm.modalId
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(0), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v("\n            Posts for campaign " + _vm._s(_vm.campaign.name) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [(_vm.buttonShow('create')) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-3"
  }, [_c('label', [_vm._v("Description")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPost.description),
      expression: "newPost.description"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Description"
    },
    domProps: {
      "value": (_vm.newPost.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newPost, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2"
  }, [_c('label', [_vm._v("Location")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPost.location),
      expression: "newPost.location"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Location"
    },
    domProps: {
      "value": (_vm.newPost.location)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newPost, "location", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2"
  }, [_c('label', [_vm._v("Hashtags")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPost.hashtag),
      expression: "newPost.hashtag"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Hashtags"
    },
    domProps: {
      "value": (_vm.newPost.hashtag)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newPost, "hashtag", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2"
  }, [_c('label', [_vm._v("Image")]), _vm._v(" "), _c('input', {
    ref: "newPostImage",
    staticClass: "form-control-file",
    attrs: {
      "type": "file",
      "id": "newPostImage"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    staticStyle: {
      "padding-top": "22px"
    }
  }, [_c('b-button', {
    staticClass: "col-xs-12",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.createPost()
      }
    }
  }, [_vm._v("\n                Create\n              ")])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('b-table', {
    attrs: {
      "striped": "",
      "bordered": "",
      "hover": "",
      "responsive": "",
      "current-page": _vm.currentPage,
      "per-page": _vm.perPage,
      "filter": _vm.filter,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "items": _vm.items,
      "fields": _vm.fields
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "imageURL",
      fn: function(row) {
        return [(row.item.imageURL) ? [_c('img', {
          staticStyle: {
            "max-height": "80px",
            "max-width": "500px"
          },
          attrs: {
            "src": row.item.imageURL,
            "alt": "image"
          }
        })] : _vm._e()]
      }
    }, {
      key: "cell(actions)",
      fn: function(row) {
        return [(_vm.acceptButtonShow(row.item.status)) ? _c('button', {
          staticClass: "btn btn-success btn-sm",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              return _vm.approvePost(row.item)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-check"
        })]) : _vm._e(), _vm._v(" "), (_vm.canEditPost(row.item)) ? _c('button', {
          staticClass: "btn btn-default btn-sm",
          attrs: {
            "type": "button",
            "data-toggle": "modal",
            "data-target": "#modal-edit-post"
          },
          on: {
            "click": function($event) {
              return _vm.showModalEditPost(row.item)
            }
          }
        }, [_vm._v("\n                    Edit\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.rejectButtonShow(row.item.status)) ? _c('button', {
          staticClass: "btn btn-danger btn-sm",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              return _vm.rejectPost(row.item)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-times"
        })]) : _vm._e(), _vm._v(" "), (_vm.showInputUpdateInstagram == row.item.id) ? _c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.instagramURL),
            expression: "instagramURL"
          }],
          staticClass: "form-control input-instagram",
          attrs: {
            "type": "text"
          },
          domProps: {
            "value": (_vm.instagramURL)
          },
          on: {
            "input": function($event) {
              if ($event.target.composing) { return; }
              _vm.instagramURL = $event.target.value
            }
          }
        }) : _vm._e(), _vm._v(" "), (_vm.updateInstagramURLShow(row.item.status)) ? _c('button', {
          staticClass: "btn btn-primary btn-sm",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              return _vm.showModalUpdateInstagramURL(row.item)
            }
          }
        }, [_vm._v("\n                    Update Instagram URL\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.showInputUpdateInstagram == row.item.id) ? _c('button', {
          staticClass: "btn btn-danger btn-sm",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              _vm.showInputUpdateInstagram = ''
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-times"
        })]) : _vm._e()]
      }
    }])
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('b-pagination', {
    attrs: {
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage,
      "size": "sm",
      "align": "center"
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    ref: "closeButton",
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "tabindex": "-1",
      "role": "dialog",
      "id": "modal-edit-post"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Description")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentPost.description),
      expression: "currentPost.description"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Description"
    },
    domProps: {
      "value": (_vm.currentPost.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentPost, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("location")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentPost.location),
      expression: "currentPost.location"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Description"
    },
    domProps: {
      "value": (_vm.currentPost.location)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentPost, "location", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Hashtags")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentPost.hashtag),
      expression: "currentPost.hashtag"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Description"
    },
    domProps: {
      "value": (_vm.currentPost.hashtag)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentPost, "hashtag", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Image")]), _vm._v(" "), _c('input', {
    ref: "editPostImage",
    staticClass: "form-control-file",
    attrs: {
      "type": "file",
      "id": "editPostImage"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    ref: "btnCloseEditPostModal",
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.editPost()
      }
    }
  }, [_vm._v("Save")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Close")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Modal title")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-aef5ce28"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Campaign/ViewPostModal.vue
// module id = 2264
// module chunks = 0